<template>
  <div>
    <cell :title="title" primary="content" @click.native="onClick" is-link>
      {{currentValue}}
    </cell>
    <popup v-model="show">
      <inline-calendar
      v-model="currentValue"
      @on-change="onSelect"
      :render-month="renderMonth"
      :start-date="startDate"
      :end-date="endDate"
      :show-last-month="showLastMonth"
      :show-next-month="showNextMonth"
      :highlight-weekend="highlightWeekend"
      :return-six-rows="returnSixRows"
      :hide-header="hideHeader"
      :hide-week-list="hideWeekList"
      :replace-text-list="replaceTextList"
      :weeks-list="weeksList"
      :custom-slot-fn="customSlotFn"
      :render-on-value-change="renderOnValueChange"
      :disable-past="disablePast"
      :disable-future="disableFuture"
      ></inline-calendar>
    </popup>
  </div>
</template>

<script>
import InlineCalendar from '../inline-calendar'
import Popup from '../popup'
import Cell from '../cell'
import props from '../inline-calendar/props'

const Props = props()
Props.title = {
  type: String,
  required: true
}

export default {
  components: {
    InlineCalendar,
    Popup,
    Cell
  },
  props: Props,
  methods: {
    onClick () {
      console.log(this.show)
      this.show = true
    },
    onSelect () {
      this.show = false
    }
  },
  data () {
    return {
      show: false,
      currentValue: ''
    }
  },
  created () {
    this.currentValue = this.value
  },
  watch: {
    value (val) {
      this.currentValue = val
    },
    currentValue (val) {
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// calendar.vue?e5d6a9da